<div [formGroup]="form()" class="flex flex-col gap-3">
  <div class="flex flex-col">
    <div class="flex items-center text-lg">
      <span>{{ 'pages.campaignForm.sections.basics.timelineLabel' | translate }}</span>
    </div>
    <div class="text-shikenso-purple-base-60 text-sm">
      {{ 'pages.campaignForm.sections.basics.timelineDescription' | translate }}
    </div>
  </div>

  <div class="flex flex-col">
    <div class="flex gap-4">
      <!-- Start Date & Time Pickers -->
      <div class="flex flex-col gap-1">
        <span class="text-sm font-bold">
          {{ 'pages.campaignForm.sections.basics.startDate' | translate }}
        </span>

        <div class="flex gap-2">
          <div class="flex min-w-[180px] cursor-pointer" (click)="openStartPicker()">
            <mat-form-field
              class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
              [class.active-datepicker]="startRangePicker?.opened"
            >
              <input
                readonly
                matInput
                [value]="form().get('startDate')?.value | date: 'dd.MM.yyyy'"
                [placeholder]="'pages.campaignForm.sections.basics.startDatePlaceholder' | translate"
              />

              <div matSuffix class="flex items-center gap-1">
                <app-icon src="icons/chevron-down.svg" [size]="20" />
              </div>
              <mat-date-range-picker #startRangePicker></mat-date-range-picker>
              <mat-error [control]="form().get('startDate')" />

              <div class="opacity-0">
                <mat-date-range-input #startRangeInput="matDateRangeInput" [rangePicker]="startRangePicker">
                  <input matStartDate formControlName="startDate" />
                  <input matEndDate formControlName="endDate" />
                </mat-date-range-input>
              </div>
            </mat-form-field>
          </div>

          <div class="flex min-w-[128px] cursor-pointer" (click)="startTimePicker.open()">
            <mat-form-field
              class="flex-1 [&_input]:pointer-events-none"
              [class.active-datepicker]="startTimePicker?.isOpen()"
            >
              <input
                matInput
                formControlName="startTime"
                [matTimepicker]="startTimePicker"
                [placeholder]="'pages.campaignForm.sections.basics.startTimePlaceholder' | translate"
                (focus)="selectAllText($event)"
                (input)="onInputChange($event, startTimePicker)"
              />

              <div matSuffix class="flex items-center gap-1">
                <app-icon src="icons/chevron-down.svg" [size]="20" />
              </div>

              <mat-timepicker #startTimePicker [options]="startTimeFilteredOptions" />
              <mat-error [control]="form().get('startTime')" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- End Date & Time Pickers -->
      <div class="flex flex-col gap-1">
        <span class="text-sm font-bold">
          {{ 'pages.campaignForm.sections.basics.endDate' | translate }}
        </span>

        <div class="flex gap-2">
          <div class="flex min-w-[180px] cursor-pointer" (click)="openEndPicker()">
            <mat-form-field
              class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
              [class.active-datepicker]="endDatePicker?.opened"
            >
              <input
                readonly
                matInput
                class="max-h-[48px]"
                [value]="form().get('endDate')?.value | date: 'dd.MM.yyyy'"
                [placeholder]="'pages.campaignForm.sections.basics.endDatePlaceholder' | translate"
              />

              <div matSuffix class="flex items-center gap-1">
                <app-icon src="icons/chevron-down.svg" [size]="20" />
              </div>
              <mat-datepicker
                #endDatePicker
                [panelClass]="datePickerUtilities.endPickerPanelClass"
                [dateClass]="
                  datePickerUtilities.endPickerDateClass(form().get('startDate')?.value, form().get('endDate')?.value)
                "
              ></mat-datepicker>
              <mat-error [control]="form().get('endDate')" />

              <div class="opacity-0">
                <input
                  matInput
                  [matDatepicker]="endDatePicker"
                  [min]="form().get('startDate')?.value"
                  [value]="form().get('endDate')?.value"
                  (dateInput)="onRangeEndDateChange($event.value ?? null)"
                />
              </div>
            </mat-form-field>
          </div>

          <div class="flex min-w-[128px] cursor-pointer" (click)="endTimePicker.open()">
            <mat-form-field
              class="flex-1 [&_input]:pointer-events-none"
              [class.active-datepicker]="endTimePicker.isOpen()"
            >
              <input
                matInput
                formControlName="endTime"
                [matTimepicker]="endTimePicker"
                [placeholder]="'pages.campaignForm.sections.basics.endTimePlaceholder' | translate"
                (focus)="selectAllText($event)"
                (input)="onInputChange($event, endTimePicker)"
              />

              <div matSuffix class="flex items-center gap-1">
                <app-icon src="icons/chevron-down.svg" [size]="20" />
              </div>

              <mat-timepicker #endTimePicker [options]="endTimeFilteredOptions" />
              <mat-error [control]="form().get('endTime')" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    @if (isViolatingMinimumDuration()) {
      <mat-error
        class="text-[10px]"
        [customErrorMessage]="'shared.form.customErrors.campaignDurationCannotBeLessThanOneHour' | translate"
      />
    }

    @if (campaignDatesError()) {
      <mat-error class="text-[10px]" [customErrorMessage]="campaignDatesError()!" />
    }

    @if (isStartInThePast()) {
      <div class="flex items-center gap-1 mt-1">
        <app-icon src="/icons/alert-circle.svg" class="w-5 h-5" color="var(--shikenso-warning-base)" />
        <span class="text-xs text-shikenso-warning-base">
          {{ 'pages.campaignForm.sections.basics.pastDataWarning' | translate }}
        </span>
      </div>
    }
  </div>
</div>
